<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1>Acknowledgment</h1>
<p>God.</p>
<p>I thank you God for giving me the opportunity to pour my heart out on paper, to translate moaning into words, and tears into joy. Writing this story has transformed my life, and I am honoured that such a mess of a story could be turned into a powerful message to empower others.</p>
<p>I would like to thank Brandon Knopp for being a conduit where which I could express the traumatic incidences in my life. He has been a source of encouragement and guide during the formation of this book.</p>
<p>I want to express my utmost gratitude to everyone who has walked with me along this journey. To those who have lifted me up when I was weak, and who prayed with me and for me, thank you. I love you all.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?3e7bbad6